// eslint-disable-next-line func-names
export default function () {
    return {
        settings: {
            adminPageTitle: undefined,
            defaultPageTitle: undefined,
            autoAcceptEntryDiag: undefined,
        },
    };
}
